export const disableLayoutAnimation = () => false;

export const measureRow = (elementId) => {
  const row = document.getElementById(elementId);

  if (!row) return null;

  const { height, top, width } = row.getBoundingClientRect();

  return {
    columnWidths: Array.from(
      row.cells,
      (cell) => cell.getBoundingClientRect().width,
    ),
    height,
    top,
    width,
  };
};

// Every row is the same height for the duration of a drag, so the slots the rows glide
// over are a stack from the first row down rather than something to measure row by row.
export const uniformSlots = ({ count, height, top }) =>
  Array.from({ length: count }, (_, index) => ({
    height,
    top: top + index * height,
  }));

export const moveId = (ids, activeRawId, overRawId) => {
  const fromIndex = ids.indexOf(activeRawId);
  const toIndex = ids.indexOf(overRawId);

  if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) return ids;

  const reordered = [...ids];

  reordered.splice(toIndex, 0, reordered.splice(fromIndex, 1)[0]);

  return reordered;
};
